import axios from "axios";
import moment from "moment";
import { useMutation } from "react-query";
import { v4 } from "uuid";

import { NICE_PAY_MID, NICE_PAY_REQUEST_URL, NICE_PAY_RETURN_URL, SERVER_HOST } from "api/constants";
import { useAppSelector } from "store/hooks";
import { getCartList } from "store/productPayment/cart";
import { getCartTotalAmount } from "store/productPayment/selectors";
import { PaymentStatus, postPayment, SaleStatus } from "api/payment";
import { getShopTID } from "store/productPayment/goods";

function submit({
  amount,
  goodsName,
  ediDate,
  signData,
  saleTID
}: {
  amount: number;
  ediDate: string;
  goodsName: string;
  signData: string;
  saleTID: string
}) {
  const form = document.createElement("form");
  form.setAttribute("charset", "EUC-KR");
  form.setAttribute("mehtod", "POST");
  form.setAttribute("action", NICE_PAY_REQUEST_URL);

  const goodsNameInput = document.createElement("input");
  goodsNameInput.setAttribute("type", "hidden");
  goodsNameInput.setAttribute("name", "GoodsName");
  goodsNameInput.setAttribute("value", goodsName);
  form.appendChild(goodsNameInput);

  const amountInput = document.createElement("input");
  amountInput.setAttribute("type", "hidden");
  amountInput.setAttribute("name", "Amt");
  amountInput.setAttribute("value", amount.toString());
  form.appendChild(amountInput);

  const midInput = document.createElement("input");
  midInput.setAttribute("type", "hidden");
  midInput.setAttribute("name", "MID");
  midInput.setAttribute("value", NICE_PAY_MID);
  form.appendChild(midInput);

  const ediDateInput = document.createElement("input");
  ediDateInput.setAttribute("type", "hidden");
  ediDateInput.setAttribute("name", "EdiDate");
  ediDateInput.setAttribute("value", ediDate);
  form.appendChild(ediDateInput);

  const moidInput = document.createElement("input");
  moidInput.setAttribute("type", "hidden");
  moidInput.setAttribute("name", "Moid");
  moidInput.setAttribute("value", saleTID);
  form.appendChild(moidInput);

  const returnUrlInput = document.createElement("input");
  returnUrlInput.setAttribute("type", "hidden");
  returnUrlInput.setAttribute("name", "ReturnURL");
  returnUrlInput.setAttribute("value", NICE_PAY_RETURN_URL);
  form.appendChild(returnUrlInput);

  const signDataInput = document.createElement("input");
  signDataInput.setAttribute("type", "hidden");
  signDataInput.setAttribute("name", "SignData");
  signDataInput.setAttribute("value", signData);
  form.appendChild(signDataInput);
  document.body.appendChild(form);

  //
  // console.log('나이스페이로 보내는 데이터\n' +
  //   `GoodsName = ${goodsName}\n` +
  //   `Amt = ${amount}\n` +
  //   `MID = ${NICE_PAY_MID}\n` +
  //   `EdiDate = ${ediDate}\n` +
  //   `Moid = ${saleTID}\n` +
  //   `ReturnURL = ${NICE_PAY_RETURN_URL}\n` +
  //   `SignData = ${signData}\n`
  // );
  //
  // alert('나이스페이로 보내는 데이터\n' +
  //   `GoodsName = ${goodsName}\n` +
  //   `Amt = ${amount}\n` +
  //   `MID = ${NICE_PAY_MID}\n` +
  //   `EdiDate = ${ediDate}\n` +
  //   `Moid = ${saleTID}\n` +
  //   `ReturnURL = ${NICE_PAY_RETURN_URL}\n` +
  //   `SignData = ${signData}\n`
  // );

  form.submit();
}

export function getVat(totalAmount: number): number {
  return Number((totalAmount - Math.ceil(totalAmount / 1.1)).toFixed(0));
}

export function getAmount(totalAmount: number) {
  return totalAmount - getVat(totalAmount);
}


export default function useNicePayRequest() {
  const productList = useAppSelector(getCartList);
  const totalAmount = useAppSelector(getCartTotalAmount);
  const shopTID = useAppSelector(getShopTID);
  const date = moment();

  const paymentData = {
    saleDate: date.format("YYYYMMDDHHmmss"),
    saleDay: date.format("YYYYMMDD"),
    saleTime: date.format("HHmmss"),
    amount: getAmount(totalAmount),
    vat: getVat(totalAmount),
    totalAmount,
  }

  return useMutation<unknown, Error, { amount: number; goodsName: string; }>(async ({ amount, goodsName }) => {
    const saleTID = v4();

    await postPayment({
      payment: [{
        shopTID,
        payAmt: paymentData.totalAmount,
        payDate: paymentData.saleDate,
        status: PaymentStatus.PROGRESS,
        supplyAmt: paymentData.amount,
        vat: paymentData.vat,
        saleTID,
      }],
      paymentProduct: productList.map(item => ({
        shopTID,
        productTID: item.productTID,
        productCode: item.productCode,
        productName: item.productKorName,
        productAmt: item.productAmt,
        saleQty: item.saleQty,
        saleAmt: item.saleAmt,
        saleTax: getVat(item.saleAmt),
        saleDate: paymentData.saleDate,
        saleDay: paymentData.saleDay,
        saleTime: paymentData.saleTime,
        saleProductStatus: SaleStatus.SALE,
        saleTID,
      })),
      paymentSale: {
        realAmt: paymentData.totalAmount,
        saleDate: paymentData.saleDate,
        saleDay: paymentData.saleDay,
        saleStatus: SaleStatus.PROGRESS,
        saleTime: paymentData.saleTime,
        shopTID,
        totalAmt: paymentData.totalAmount,
        vat: paymentData.vat,
        saleTID,
      }
    })

    const ediDate = moment().format('YYYYMMDDHHmmss')
    const signData = await axios.request<string>({
      url: `${SERVER_HOST}/nicepay/signData`,
      method: "GET",
      params: {
        price: amount.toString(),
        ediDate
      }
    }).then(response => response.data);

    submit({ amount, goodsName, ediDate: ediDate, signData, saleTID });
  });
}